/**
 * Defines all possible loading states for Export dialog
 */
export var ExportLoadingState;
(function (ExportLoadingState) {
    ExportLoadingState[ExportLoadingState["None"] = 0] = "None";
    ExportLoadingState["Success"] = "success";
    ExportLoadingState["Canceled"] = "canceled";
    ExportLoadingState["Loading"] = "loading";
    ExportLoadingState["Error"] = "error";
    ExportLoadingState["TooManyRows"] = "tooManyRows";
})(ExportLoadingState || (ExportLoadingState = {}));
